import { memo } from 'react';
import { Picture } from '@ui';
import { starYellow, starGreyRecipeRating } from '@images';
import './index.scss';

const ratingTitle = stars => {
  let title;
  switch (stars) {
    case 1:
      title = 'Очень плохо';
      break;
    case 2:
      title = 'Плохо';
      break;
    case 3:
      title = 'Так себе';
      break;
    case 4:
      title = 'Хорошо';
      break;
    case 5:
      title = 'Прекрасно';
      break;
    default:
      title = 'Прекрасно';
      break;
  }
  return title;
};

const ReviewProductModalStars = ({ rating }) => {
  const starsArr = Array.from(Array(rating).keys());
  const greyStarsArr = Array.from(Array(5 - rating).keys());
  return (
    <div className='ReviewProductModalStars'>
      {starsArr?.map((i, ind) => (
        <Picture
          key={ind}
          className='ReviewProductModalStars__star'
          icon={starYellow}
          height='20'
        />
      ))}
      {greyStarsArr?.map((i, ind) => (
        <Picture
          key={ind}
          className='ReviewProductModalStars__star'
          icon={starGreyRecipeRating}
          height='20'
        />
      ))}
      <div className='ReviewProductModalStars__text'>{ratingTitle(rating)}</div>
    </div>
  );
};

export default memo(ReviewProductModalStars);
